

// 网购维权——淘宝，主流程
const tbMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `power/tb/index${i + 1}`,
  name: `powerTbIndex${i + 1}`,
  component: () => import(`@/views/shopping/power/tb/index${i + 1}.vue`),
}));
// 网购维权——京东，主流程
const jdMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `power/jd/index${i + 1}`,
  name: `powerJdIndex${i + 1}`,
  component: () => import(`@/views/shopping/power/jd/index${i + 1}.vue`),
}));

// 网购维权——拼多多，主流程
const pddMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `power/pdd/index${i + 1}`,
  name: `powerPddIndex${i + 1}`,
  component: () => import(`@/views/shopping/power/pdd/index${i + 1}.vue`),
}));

// 网购维权——抖音，主流程
const dyMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `power/dy/index${i + 1}`,
  name: `powerDyIndex${i + 1}`,
  component: () => import(`@/views/shopping/power/dy/index${i + 1}.vue`),
}));

export default {
  path: "/shopping",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    // 网购维权——淘宝，主流程
    ...tbMainRoutes,
    // 网购维权——京东，主流程
    ...jdMainRoutes,

    // 网购维权——拼多多，主流程
    ...pddMainRoutes,
    // 网购维权——抖音，主流程
    ...dyMainRoutes,

  ],
};
